import { Box, Grid, Modal, Typography } from "@mui/material";
import React, { ReactNode, useState } from "react";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
interface Props {
  handleDel: Function;
  text: string | ReactNode;
  setOpenDeleteModal: (open: boolean) => void;
  openDeleteModal: boolean;
  onCloseModal?: Function;
}
const DeleteModal = ({
  handleDel,
  text,
  openDeleteModal,
  setOpenDeleteModal,
  onCloseModal,
}: Props) => {
  return (
    <div>
      <Modal
        open={openDeleteModal}
        onClose={() => {
          setOpenDeleteModal(false);
          onCloseModal!();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Typography
            component={"p"}
            display={"block"}
            textAlign={"center"}
            fontWeight={"bold"}
            marginBottom={"3rem"}
            fontSize={"14px"}
          >
            {text}
          </Typography>
          <Grid container justifyContent={"center"} gap={"1rem"}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              sx={{
                backgroundColor: "#E6123D",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              padding={"0.5rem"}
              maxWidth={"150px !important"}
            >
              <Typography
                textAlign={"center"}
                color={"#FFF"}
                fontWeight={"bold"}
                onClick={() => handleDel()}
              >
                بله
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              sx={{
                backgroundColor: "#607D8B",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              padding={"0.5rem"}
              maxWidth={"150px !important"}
            >
              <Typography
                textAlign={"center"}
                color={"#FFF"}
                fontWeight={"bold"}
                onClick={() => {
                  setOpenDeleteModal(false);
                  onCloseModal!();
                }}
              >
                خیر
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default DeleteModal;
